// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + {"9446":"5c5974ea0c6e7b7d","92920":"5c5974ea0c6e7b7d"}[chunkId] + ".css";
};